import {connect} from 'react-redux';
import navigateBack from 'Data/actionCreators/explorer/navigateBack';
import setJourneyStop from 'Data/actionCreators/journey/setJourneyStop';
import setRouteParameters from 'Data/actionCreators/journey/setRouteParameters';
import hideCard from 'Data/actionCreators/kiosk/hideCard';
import navigate from 'Data/actionCreators/kiosk/navigate';
import selectRouteOption from 'Data/actionCreators/kiosk/selectRouteOption';
import getEvents from 'Data/selectors/getEvents';
import {getNavigation} from 'Utils/explorer/getNavigation';
import LocationDetailsCard from 'Components/layouts/kiosk/KioskLayout/LayoutComponents/Locations/LocationDetailsCard';

const mapStateToProps = state => {
    return {
        hasEvents: getEvents(state).length > 0,
        timeZone: state.pageState.layout.config.settings.timeZone,
        navigation: getNavigation(state),
        location: getNavigation(state)?.item,
        showBackButton: !state.pageState.explorerMap.navigationHistory[
            state.pageState.explorerMap.navigationHistory.length - 1
        ]?.options.isMapClick,
        selectedRouteOption: state.pageState.explorerMap.selectedRouteOption,
        travelTimeMins: Math.round(state.pageState.explorerMap.journey.travelTimeMins),
    };
};

export default connect(
    mapStateToProps,
    {
        navigate,
        navigateBack,
        selectRouteOption,
        setRouteParameters,
        hideCard,
        setJourneyStop,
    }
)(LocationDetailsCard);
